import React from 'react';
import { Alert, Spin } from 'antd';

export interface StatusBarProps {
  containerClassName?: string;
  isLoading: boolean;
  error?: string;
}

const StatusBar: React.FC<StatusBarProps> = ({
  isLoading,
  error,
  containerClassName,
}) => {
  return (
    <div className={containerClassName || 'photo-status-bar-container'}>
      {isLoading && <Spin />}
      {error !== undefined && <Alert title={error} type={'error'} />}
    </div>
  );
};

export default StatusBar;
